<div class="col-12" [formGroup]="form">
  <label class="form-label" [for]="daysOfWeek[0]">{{ 'common.dayOfWeek' | translate }}*</label>

  <ng-container formArrayName="days">
    @for (day of daysOfWeek; track day; let i = $index) {
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="{{ day }}"
          [formControl]="days.get('' + i)"
          [value]="days.value[i]">
          <label class="form-check-label" for="{{ day }}">{{ 'common.day.' + day | translate }}</label>
        </div>
      }
    </ng-container>
  </div>
